export default __webpack_public_path__ + "static/media/img_clinic_patients@3x.5c88801c.png";